/** 
 * Text length limiter Class
 * 
 * This class is used to limit text length
 * 
 */
export class LimitText{

    constructor(text, limit){
        this.text = text;
        this.limit = limit;
    }

    get limitOutput() {
        return this.limitText();
    }

    limitText() {
        if(!this.text) return this.text;
        return (this.text).replace(/^\s+/g, '').substr(0, (this.limit - 3) ).replace(/\s+$/g, '').concat('...');
    }
    
}